export const insightsKeys = {
	all: ['crm', 'insights'],
	suggestions: (filters) => ['crm', 'insights', 'suggestions', filters],
	dailyPlan: () => ['crm', 'insights', 'daily-plan'],
};

export const insightsMutationKeys = {
	accept: ['crm', 'insights', 'accept'],
	dismiss: ['crm', 'insights', 'dismiss'],
	regenerateDaily: ['crm', 'insights', 'regenerate-daily'],
	nextAction: ['crm', 'insights', 'next-action'],
};
